import * as React from "react";
import { SVGProps } from "react";
const SvgPrinter = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M27 15h-2V5c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v10H5c-1.1 0-2 .9-2 2v9c0 1.1.9 2 2 2h22c1.1 0 2-.9 2-2v-9c0-1.1-.9-2-2-2ZM9 5h14v10H9V5Zm18 21H5v-9h22v9Zm-3.5-5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5-1.5-.7-1.5-1.5.7-1.5 1.5-1.5ZM11 11h10v2H11v-2Zm0-4h10v2H11V7Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPrinter;
